/** Checks if proxy exists. This is needed for vNext experiments */
export const isNextSupportedBrowser = () => {
  return !!window.Proxy;
};
